import(/* webpackMode: "eager", webpackExports: ["AddToCart"] */ "/vercel/path0/apps/store-vercel/src/app/ui/cart/add-to-cart.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/store-vercel/src/app/ui/product/image.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/store-vercel/src/lib/loader.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@19_t7gk7jqkblrv2ydw2mgnor47ki/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.0_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.52.0_react-dom@19_t7gk7jqkblrv2ydw2mgnor47ki/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectTrigger","SelectValue","SelectContent","SelectGroup","SelectItem"] */ "/vercel/path0/packages/ui/src/components/ui/select.tsx");
